export class Potions {

  constructor(player, setup) {
    this.player = player;
    this.setup = setup;
  }


  boosts() {
    return {
      attack: this.activeAttackBoost(),
      strength: this.activeStrengthBoost(),
      ranged: this.activeRangeBoost(),
      magic: this.activeMagicBoost(),
    }
  }

  activeAttackBoost() {
    let lvl = this.player.attack.level;
    let boost = 0;

    // console.log(atkLvl, atkLvl * 0.15 + 5, this.selectedPotions.attack.id);

    switch (this.setup.potions.attack.id) {
      case 121: //Atk Pot
        boost = this.calculateBoost(lvl, 'basic');
        break;

      case 2436: //Super
      case 23697: //Divine
        boost = this.calculateBoost(lvl, 'super');
        break;

      case 11730: //Overload
        boost = this.calculateBoost(lvl, 'overload');
        break;
    }

    return Math.floor(boost);
  }

  activeStrengthBoost() {
    let lvl = this.player.strength.level;
    let boost = 0;

    // console.log(atkLvl, atkLvl * 0.15 + 5, this.selectedPotions.attack.id);

    switch (this.setup.potions.strength.id) {
      case 113: //Str Pot
        boost = this.calculateBoost(lvl, 'basic');
        break;

      case 2440: //Super
      case 23709: //Divine
        boost = this.calculateBoost(lvl, 'super');
        break;

      case 11730: //Overload
        boost = this.calculateBoost(lvl, 'overload');
        break;
    }

    return Math.floor(boost);
  }

  activeMagicBoost() {
    let lvl = this.player.magic.level;
    let boost = 0;

    switch (this.setup.potions.magic.id) {
      case 1907: //Wizard mind bomb
        boost = lvl > 50 ? 3 : 4;
        break;

      case 9763: //Magic cape
        boost = 1;
        break;

      case 3040: //Basic Pot
      case 23745: //Divine
      case 22449: //Battlemage
        boost = 4; //Magic is static boost
        break;

      case 16152: //Super
        boost = this.calculateBoost(lvl, 'super');
        break;

      case 11730: //Overload
        boost = this.calculateBoost(lvl, 'overload');
        break;

      case 20724: //Imbued Heart:
        boost = lvl * 0.1 + 1;
        break;
    }

    return Math.floor(boost);
  }


  activeRangeBoost() {
    let lvl = this.player.ranged.level;
    let boost = 0;

    // console.log('rangedBoost', lvl, this.setup.potions.ranged.id);

    switch (this.setup.potions.ranged.id) {
      case 9757: //Ranging cape
        boost = 1;
        break;

      case 7208: //Wild pie
        boost = 4;
        break;

      case 169: //Ranging pot
      case 23733: //Devine
      case 22461: //Bastion
        boost = lvl * 0.1 + 4;
        break;

      case 11722: //Super
        boost = this.calculateBoost(lvl, 'super');
        break;

      case 11730: //Overload
        boost = this.calculateBoost(lvl, 'overload');
        break;
    }

    // console.log(boost);
    return Math.floor(boost);
  }

  calculateBoost(level, potionType) {
    switch (potionType) {
      case 'basic':
        return level * 0.1 + 3;
      case 'super':
        return (level * 0.15) + 5;
      case 'overload':
        return level * 0.16 + 6;
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/potions.js